/**
 * The values onboarding and the goal form offer. The canonical ids live in
 * @examing/types and the API whitelists exactly those; the web bundle cannot
 * import workspace TypeScript, so they are repeated here and a parity test
 * (modules/__parity__) fails the build if they drift.
 */
/** The exams a learner can prepare for, up to MAX_GOALS at once. Mirrors `LEARNER_EXAMS` (parity test). */
export const EXAMS = ['DTM', 'MILLIY_SERTIFIKAT', 'IELTS', 'SAT', 'ATTESTATSIYA', 'LANGUAGES'] as const;
export const MAX_GOALS = 3;

export const AGE_RANGES = ['10-14', '15-18', '19-24', '25-35', '35+'] as const;

/** DTM: the grade, and exactly DTM_SUBJECT_COUNT profile subjects. */
export const DTM_GRADES = ['9-sinf', '10-sinf', '11-sinf', 'litsey_kollej', 'mustaqil'] as const;
export const DTM_SUBJECTS = ['matematika', 'fizika', 'kimyo', 'biologiya', 'tarix', 'english', 'geografiya', 'adabiyot'] as const;
export const DTM_SUBJECT_COUNT = 2;
/** Milliy Sertifikat: one or more subjects. */
export const MILLIY_SERTIFIKAT_SUBJECTS = ['matematika', 'ona_tili', 'fizika', 'kimyo', 'biologiya', 'tarix', 'chet_tili'] as const;
/** Milliy Sertifikat: target and awarded grades. */
export const MILLIY_SERTIFIKAT_GRADES = ['A_PLUS', 'A', 'B_PLUS', 'B', 'C_PLUS', 'C'] as const;
/** SAT: the level. */
export const EXAM_LEVELS = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'] as const;
/** IELTS: the band. `4.5` is "4.5 or below". */
export const IELTS_BANDS = ['4.5', '5.0', '5.5', '6.0', '6.5', '7.0', '7.5', '8.0', '8.5', '9.0'] as const;
/** Attestation: the current category, and one or more subjects. `boshqa` is "another subject / pedagogy only". */
export const ATTESTATION_CATEGORIES = ['mutaxassis', 'ikkinchi_toifa', 'birinchi_toifa', 'oliy_toifa'] as const;
export const ATTESTATION_SUBJECTS = [
  'boshlangich_talim', 'informatika', 'matematika', 'fizika', 'kimyo', 'biologiya', 'ona_tili', 'tarix', 'english', 'russian', 'boshqa',
] as const;
/** Foreign languages: one or more. */
export const LANGUAGE_OPTIONS = ['english', 'russian', 'arabic', 'german', 'turkish', 'korean'] as const;

/** The one answer a goal takes for each exam that has one: grade, level or category. */
export const LEVEL_OPTIONS: Readonly<Record<string, readonly string[]>> = {
  DTM: DTM_GRADES,
  MILLIY_SERTIFIKAT: MILLIY_SERTIFIKAT_GRADES,
  IELTS: IELTS_BANDS,
  SAT: EXAM_LEVELS,
  ATTESTATSIYA: ATTESTATION_CATEGORIES,
};

/** The subjects or languages a goal takes for each exam that has them. */
export const SUBJECT_OPTIONS: Readonly<Record<string, readonly string[]>> = {
  DTM: DTM_SUBJECTS,
  MILLIY_SERTIFIKAT: MILLIY_SERTIFIKAT_SUBJECTS,
  ATTESTATSIYA: ATTESTATION_SUBJECTS,
  LANGUAGES: LANGUAGE_OPTIONS,
};

export const MINUTE_OPTIONS = [30, 60, 120, 180] as const;
export const PRESET_TIMEFRAMES = ['10_DAYS', '1_MONTH', '3_MONTHS', '6_MONTHS'] as const;
export const CUSTOM_TIMEFRAME = 'CUSTOM';

export const MIN_TARGET_PERCENT = 50;
export const MAX_TARGET_PERCENT = 95;
export const DEFAULT_TARGET_PERCENT = 80;

/** A topic needs this many answers before it counts toward the plan. */
export const MIN_ANSWERS_FOR_MASTERY = 8;

/** What every goal shares when a learner has none yet: the most common daily time and the default target. */
export const DEFAULT_SHARED = { dailyStudyMinutes: 60, targetPercent: DEFAULT_TARGET_PERCENT };
